import { useState, useEffect } from 'react';
import { api } from '../services/api';

/**
 * Hook personnalisé pour gérer les permissions de pointage
 * Détermine si l'utilisateur a accès au kiosque uniquement ou aux fonctions admin
 */
const usePointagePermissions = () => {
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState({
    hasKioskOnly: false,      // Uniquement kiosque
    hasAdminAccess: false,    // Accès admin/gestion
    hasAnyAccess: false       // Au moins un accès
  });

  useEffect(() => {
    const loadPermissions = async () => {
      try {
        setLoading(true);
        
        console.log('🔍 [usePointagePermissions] Chargement des permissions...');
        
        // ✅ CORRECTION : Utiliser api.auth au lieu de api.permissions
        const response = await api.auth.getMyPermissions();
        
        console.log('📋 [usePointagePermissions] Réponse API complète:', response);
        
        if (response.success && response.data) {
          // ✅ CORRECTION : Les permissions sont dans response.data.rolePermissions
          const userPermissions = response.data.rolePermissions || [];
          
          console.log('🎭 [usePointagePermissions] Permissions de rôle:', userPermissions);
          console.log('📊 [usePointagePermissions] Structure première permission:', userPermissions[0]);
          
          // Vérifier les permissions spécifiques au pointage
          const hasKioskView = userPermissions.some(p => p.permission_key === 'POINTAGES.KIOSK.VIEW');
          const hasPointagesAccess = userPermissions.some(p => p.permission_key === 'POINTAGES.ACCESS');
          
          console.log('🔍 [usePointagePermissions] Vérifications:');
          console.log('  - POINTAGES.ACCESS:', hasPointagesAccess ? '✅' : '❌');
          console.log('  - POINTAGES.KIOSK.VIEW:', hasKioskView ? '✅' : '❌');
          
          // Vérifier si l'utilisateur a d'AUTRES permissions que KIOSK dans le module POINTAGES
          const otherPointagePermissions = userPermissions.filter(p => 
            p.module === 'POINTAGES' && 
            p.permission_key !== 'POINTAGES.KIOSK.VIEW' &&
            p.permission_key !== 'POINTAGES.ACCESS'
          );
          
          console.log('📍 [usePointagePermissions] Autres permissions POINTAGES:', otherPointagePermissions);
          console.log('📍 [usePointagePermissions] Nombre autres permissions:', otherPointagePermissions.length);
          
          const hasAdminAccess = otherPointagePermissions.length > 0;
          const hasKioskOnly = hasKioskView && !hasAdminAccess;
          
          console.log('🎯 [usePointagePermissions] DIAGNOSTIC FINAL:');
          console.log('  - hasKioskOnly:', hasKioskOnly ? '✅ TRUE' : '❌ FALSE');
          console.log('  - hasAdminAccess:', hasAdminAccess ? '✅ TRUE' : '❌ FALSE');
          console.log('  - hasAnyAccess:', (hasPointagesAccess || hasKioskView) ? '✅ TRUE' : '❌ FALSE');
          
          setPermissions({
            hasKioskOnly,
            hasAdminAccess,
            hasAnyAccess: hasPointagesAccess || hasKioskView
          });
        }
      } catch (error) {
        console.error('❌ [usePointagePermissions] Erreur chargement permissions:', error);
      } finally {
        setLoading(false);
        console.log('🏁 [usePointagePermissions] Chargement terminé');
      }
    };

    loadPermissions();
  }, []);

  return { ...permissions, loading };
};

export default usePointagePermissions;